var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('AgList',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.isRoot),expression:"isRoot"}],on:{"ag-selected":_vm.updateAg}},'AgList',{ id: _vm.id, loading: _vm.agLoading },false)),_c('router-view',_vm._b({directives:[{name:"show",rawName:"v-show",value:(!_vm.isRoot),expression:"!isRoot"}]},'router-view',{
            item: _vm.agSelected
        },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }